_ref$maxAttempts